import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TldrCollpasibleSection from "./TldrCollpasibleSection";
import _ from "lodash";
import { StyledDetailsSectionGroup } from "../styled/details/stylesDetails";
import EditableLabel from "./EditableLabel";
import { wsUpdatePage } from "../../_actions/webSocketAction";
import { withTranslation } from "react-i18next";

class TldrArtboardDetails extends Component {
  constructor(props) {
    super(props);
    const pageId = props.editor.activePage?.id;
    const page = props.pagestore.pages[props.editor.activePage?.id];

    this.state = {
      pageId: pageId,
      lastUpdated: page?.last_updated,
      collapse: true,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const pageId = nextProps.editor.activePage?.id;
    const page = nextProps.pagestore.pages[nextProps.editor.activePage?.id];
    if (
      pageId !== prevState.pageId ||
      page?.last_updated > prevState.lastUpdated
    ) {
      return {
        pageId: pageId,
        lastUpdated: page?.last_updated,
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(this.state, nextState);
  }

  render() {
    const { collapse } = this.state;
    const { editor, pagestore, t } = this.props;
    const pageId = editor.activePage.id;
    const page = pagestore.pages[pageId];
    return (
      <>
        <TldrCollpasibleSection
          title="Artboard"
          collapse={collapse}
          onToggleCollapse={this.handleToggleChange}
        >
          <StyledDetailsSectionGroup>
            <div className="title">{t("artboard_name")}</div>
            <EditableLabel
              text={page?.title ? page.title : ""}
              labelClassName="layernamevaluename"
              inputClassName="layernamevalueinput"
              onFocus={this.handleLayerNameFocus}
              onFocusOut={this.handleLayerNameFocusOut}
              showIcon={true}
              inputMaxLength={50}
              labelPlaceHolder={
                page?.title ? page.title : t("name_artboard_placeholder")
              }
            />
          </StyledDetailsSectionGroup>
        </TldrCollpasibleSection>
      </>
    );
  }

  handleToggleChange = () => {
    const { collapse } = this.state;

    this.setState({ collapse: !collapse });
  };

  handleLayerNameFocus = (text) => {};

  handleLayerNameFocusOut = (text) => {
    const { editor } = this.props;
    const pageId = editor.activePage.id;

    const message = {
      page: pageId,
      title: text,
    };
    this.props.wsUpdatePage(message);
  };
}

TldrArtboardDetails.propTypes = {
  editor: PropTypes.object.isRequired,
  pagestore: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  pagestore: state.pagestore,
});

const mapDispatchToProps = (dispatch) => ({
  wsUpdatePage: (payload) => dispatch(wsUpdatePage(payload)),
});

export default withTranslation(["workspace"])(
  connect(mapStateToProps, mapDispatchToProps)(TldrArtboardDetails)
);
